import ResetPasswordModal from './reset_password_modal'
export default ResetPasswordModal
